import { render, staticRenderFns } from "./SysCustomFormModal.Style#Drawer.vue?vue&type=template&id=640daabb&scoped=true"
import script from "./SysCustomFormModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./SysCustomFormModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./SysCustomFormModal.Style#Drawer.vue?vue&type=style&index=0&id=640daabb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640daabb",
  null
  
)

export default component.exports